/* src/app/dialogs/crm-address-editor/crm-address-editor.component.css */
input[type=time] {
  text-align: center;
}
.msgbox {
  border-radius: 10px;
  text-align: center;
}
/*# sourceMappingURL=crm-address-editor.component-6WBPSSJI.css.map */
